module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst fieldConfig = model.config || {}\nvar disabled = config.disabled;\nvar isFilterField = false;\nif(!!formMapping && !!formMapping.fieldConfig) {\nisFilterField = !!formMapping.fieldConfig.isFilterField;\n}\nconst cssClasses = [];\nif(typeof(additionalCSSClass) !== 'undefined'){\ncssClasses.push(additionalCSSClass);\n}\nif(model.additionalCSSClass) {\ncssClasses.push(model.additionalCSSClass);\n}\nif(config.bootstrapVersion){\ncssClasses.push('form-control')\n}\nif(!model.placeholder){\nif(model.placeholderKey) \t\t\tmodel.placeholder = storage.__(model.placeholderKey);\nelse if(fieldConfig.placeholder) \tmodel.placeholder = storage.__(fieldConfig.placeholder);\nelse if(fieldConfig.placeholderKey) model.placeholder = storage.__(fieldConfig.placeholderKey);\n}\nconst additionalClasses = ['input-group date']\nif(fieldConfig.showInline) \t\t\t\t\t\tadditionalClasses.push('showInline');\nif((config.airDatePicker || {}).onlyTimepicker) additionalClasses.push('onlyTimepicker');\nif(disabled) \t\t\t\t\t\t\t\t\tadditionalClasses.push('disabled');\nconst dataFlag = 'dataDATE'\n%><div class=\"<%- additionalClasses.join(' ') %>\"><%\nif(config.bootstrapVersion && !fieldConfig.showInline){\n%><span class=\"input-group-text input-group-addon datepicker-action-icon\"><i class=\"fi fi-calendar\" aria-hidden=\"true\"></i></span><%\n}\n%><input\nclass=\"<%- cssClasses.join(' ') %>\"\ndata-field-type=\"text\"\ntype=\"text\"\ndata-field-code=\"<%- model.fieldCode %>\"\ndata-date=\"<%= isFilterField ? model.filterValue : model[dataFlag] %>\"\n<%- (disabled ? 'disabled=\"disabled\"' : ''); %>\nplaceholder=\"<%= model.placeholder || '' %>\"\n<%- (config.inputSize ? `size=\"${config.inputSize}\"` : ''); %>\n/><%\nif(!config.bootstrapVersion && !fieldConfig.showInline){\n%><span class=\"input-group-addon datepicker-action-icon\"><i class=\"fi fi-calendar\" aria-hidden=\"true\"></i></span><%\n}\n%></div>"
  , __filename = "..\\frontend-controller\\baseComponents\\form\\fields\\air-datetime-picker.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const fieldConfig = model.config || {}
var disabled = config.disabled;
var isFilterField = false;
if(!!formMapping && !!formMapping.fieldConfig) {
isFilterField = !!formMapping.fieldConfig.isFilterField;
}
const cssClasses = [];
if(typeof(additionalCSSClass) !== 'undefined'){
cssClasses.push(additionalCSSClass);
}
if(model.additionalCSSClass) {
cssClasses.push(model.additionalCSSClass);
}
if(config.bootstrapVersion){
cssClasses.push('form-control')
}
if(!model.placeholder){
if(model.placeholderKey) 			model.placeholder = storage.__(model.placeholderKey);
else if(fieldConfig.placeholder) 	model.placeholder = storage.__(fieldConfig.placeholder);
else if(fieldConfig.placeholderKey) model.placeholder = storage.__(fieldConfig.placeholderKey);
}
const additionalClasses = ['input-group date']
if(fieldConfig.showInline) 						additionalClasses.push('showInline');
if((config.airDatePicker || {}).onlyTimepicker) additionalClasses.push('onlyTimepicker');
if(disabled) 									additionalClasses.push('disabled');
const dataFlag = 'dataDATE'

    ; __line = 28
    ; __append("<div class=\"")
    ; __append( additionalClasses.join(' ') )
    ; __append("\">")
    ; 
if(config.bootstrapVersion && !fieldConfig.showInline){

    ; __line = 30
    ; __append("<span class=\"input-group-text input-group-addon datepicker-action-icon\"><i class=\"fi fi-calendar\" aria-hidden=\"true\"></i></span>")
    ; 
}

    ; __line = 32
    ; __append("<input\nclass=\"")
    ; __line = 33
    ; __append( cssClasses.join(' ') )
    ; __append("\"\ndata-field-type=\"text\"\ntype=\"text\"\ndata-field-code=\"")
    ; __line = 36
    ; __append( model.fieldCode )
    ; __append("\"\ndata-date=\"")
    ; __line = 37
    ; __append(escapeFn( isFilterField ? model.filterValue : model[dataFlag] ))
    ; __append("\"\n")
    ; __line = 38
    ; __append( (disabled ? 'disabled="disabled"' : '') )
    ; __append("\nplaceholder=\"")
    ; __line = 39
    ; __append(escapeFn( model.placeholder || '' ))
    ; __append("\"\n")
    ; __line = 40
    ; __append( (config.inputSize ? `size="${config.inputSize}"` : '') )
    ; __append("\n/>")
    ; __line = 41
    ; 
if(!config.bootstrapVersion && !fieldConfig.showInline){

    ; __line = 43
    ; __append("<span class=\"input-group-addon datepicker-action-icon\"><i class=\"fi fi-calendar\" aria-hidden=\"true\"></i></span>")
    ; 
}

    ; __line = 45
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\form\fields\air-datetime-picker.ejs

}